import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import {
  BIG_MARGIN,
  colorsPalette,
  LARGE_MARGIN,
  MIDDLE_MARGIN,
  SUBMIDDLE_MARGIN,
} from '../../theme';
import { Background } from '../../types';

const useStyles = (background?: Background | null) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        padding: `${MIDDLE_MARGIN}px 0`,
        background: colorsPalette.blueDark,
        [theme.breakpoints.up('sm')]: {
          background:
            background === Background.Dark ? colorsPalette.blueDark : colorsPalette.blackSecondary,
          padding: `${LARGE_MARGIN}px 0`,
        },
      },
      container: {
        maxWidth: 1000,
      },
      title: {
        marginBottom: MIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginBottom: SUBMIDDLE_MARGIN,
        },
      },
      accordionsWrapper: {
        width: '100%',
      },
    }),
  );

export const useSingleAccordionStyles = makeStyles((theme: Theme) =>
  createStyles({
    description: {
      color: colorsPalette.gray,
    },
    icon: {
      width: 18,
      height: 18,
      marginLeft: SUBMIDDLE_MARGIN,
      marginRight: SUBMIDDLE_MARGIN,
      transform: 'rotate(180deg)',
    },
    accordionRoot: {
      background: 'transparent',
      boxShadow: 'none',
      marginBottom: SUBMIDDLE_MARGIN,
      '&::before': {
        content: 'none',
      },
      '&$accordionExpanded': {
        marginBottom: MIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginBottom: BIG_MARGIN,
        },
      },
      '&:last-child': {
        marginBottom: 0,
        '&$accordionExpanded': {
          marginBottom: 0,
        },
      },
    },
    accordionExpanded: {},
    accordionSummaryRoot: {
      padding: 0,
      background: colorsPalette.violetAnalyticsCard,
      borderRadius: 4,
      '& $accordionSummaryExpanded': {
        margin: 0,
      },
    },
    accordionSummaryExpanded: {},
    accordionSummaryContent: {
      padding: SUBMIDDLE_MARGIN,
      margin: 0,
    },
    accountDetailsRoot: {
      padding: SUBMIDDLE_MARGIN,
      paddingBottom: 0,
      [theme.breakpoints.up('md')]: {
        padding: `${MIDDLE_MARGIN}px ${SUBMIDDLE_MARGIN}px 0 ${SUBMIDDLE_MARGIN}px`,
      },
    },
  }),
);

export default useStyles;
